var antlr4 = require('antlr4/index');
var FiltersLexer = require('./parsers/generated/FiltersLexer');
var FiltersParser = require('./parsers/generated/FiltersParser');
var FiltersDSLGenerator = require('./parsers/FiltersDSLGenerator').FiltersDSLGenerator;

module.exports = {
  create: (filterStr) => {
    return new FilterDecomposer(filterStr);
  },
};

function FilterDecomposer(filterStr) {
  this._filterStr = filterStr;
  this._buildFilterObject();
}

FilterDecomposer.prototype._buildFilterObject = function () {
  var chars = new antlr4.InputStream(this._filterStr);
  var lexer = new FiltersLexer.FiltersLexer(chars);
  var tokens = new antlr4.CommonTokenStream(lexer);
  var parser = new FiltersParser.FiltersParser(tokens);

  parser.buildParseTrees = true;
  var tree = parser.filters();

  var dsl = new FiltersDSLGenerator();
  antlr4.tree.ParseTreeWalker.DEFAULT.walk(dsl, tree);
  this._filterObject = dsl.getFiltersDSLObject();
};

FilterDecomposer.prototype.getFilterObject = function () {
  return this._filterObject;
};

FilterDecomposer.prototype.getFilterJSON = function () {
  return JSON.stringify(this._filterObject);
};
